<template>
  <div class="main">
    <div class="main-header">
      <span>{{ $t('收货人信息') }}</span>
      <es-button type="text" @click="openDialog">{{ $t('新增收货地址') }}</es-button>
    </div>
    <div class="main-body">
      <es-radio-group v-model="choosedAdd" style="width: 100%" v-if="addresses.length > 0">
        <div :class="['address-card', { defaultAdd: item.defaultFlag }]" v-for="(item, index) in addresses" :key="index">
          <es-radio :label="item.addressId" v-if="showAll || choosedAdd === item.addressId">
            <div class="name">
              <es-tooltip effect="dark" :content="item.contact" placement="top-start" v-if="item.contact.length > 8">
                <span>{{ item.contact.slice(0, 8) + '...' }}</span>
              </es-tooltip>
              <span v-else>
                {{ item.contact }}
              </span>
            </div>
            <div class="phone">
              <es-tooltip effect="dark" :content="item.contactNumber" placement="top-start" v-if="item.contactNumber.length > 8">
                <span>{{ item.contactNumber.slice(0, 8) + '...' }}</span>
              </es-tooltip>
              <span v-else> {{ item.contactNumber }} </span>
            </div>
            <div class="address">{{ item.addressAll }}</div>
          </es-radio>
        </div>
      </es-radio-group>
      <div style="text-align: center; color: #999; font-size: 12px" v-if="addresses.length == 0">
        <img src="./../assets/common/change.png" />

        <div>{{ $t('您还没有收货地址，赶快添加吧！') }}</div>
      </div>
    </div>
    <div @click="showAll = !showAll" class="main-footer">
      <span> {{ showAll ? $t('收起') : $t('更多地址') }}</span>
      <i :class="['es-icon-d-arrow-right', { rotate90: showAll }]"></i>
    </div>
    <es-dialog :title="$t(`新增收货地址`)" class="dialog" :visible.sync="dialogVisible" v-if="dialogVisible">
      <es-form :model="form" class="demo-form-inline" :label-width="labelWith" label-position="left" :rules="rules" ref="ruleForm">
        <es-form-item :label="$t(`姓名`)" label-width="80px" prop="user">
          <es-input v-model="form.user" :placeholder="$t(`请输入收货人`)"></es-input>
        </es-form-item>
        <es-form-item :label="$t(`电话`)" label-width="80px" prop="phone">
          <es-input v-model="form.phone" :placeholder="$t(`请输入联系电话`)" maxlength="24"></es-input>
        </es-form-item>
        <es-form-item :label="$t(`地址`)" prop="address" label-width="80px">
          <es-cascader
            :options="cascaderData"
            :props="props"
            v-model="form.address"
            @active-item-change="handleItemChange"
            style="width: 100%"
          ></es-cascader>
        </es-form-item>
        <es-form-item :label="$t(`详细地址`)" prop="DetailedAddress">
          <es-input v-model="form.DetailedAddress" :placeholder="$t(`请输入详细地址`)" type="textarea" :rows="3"></es-input>
          <br />
        </es-form-item>
      </es-form>
      <span slot="footer">
        <es-button type="primary" @click="onSubmit">{{ $t('保存') }}</es-button>
        <es-button variant="outline" @click="dialogVisible = false">{{ $t('取消') }}</es-button>
      </span>
    </es-dialog>
  </div>
</template>
<script>
import { $t, getLocale } from '@/locales'

export default {
  data() {
    return {
      dialogVisible: false,
      addresses: [],
      showAll: false,
      choosedAdd: '',
      form: {
        user: '',
        phone: '',
        address: [],
        DetailedAddress: '',
        defaultFlag: '',
      },
      props: {
        value: 'addressCode',
        label: 'address',
        children: 'cities',
      },
      cascaderData: [],
      rules: {
        user: [
          { max: 50, message: $t('长度不可以超过50个字符'), trigger: 'blur' },
          { required: true, message: $t('请输入收货人'), trigger: 'blur' },
        ],

        phone: [
          { required: true, message: $t('请输入联系电话'), trigger: 'blur' },
          { max: 20, message: $t('长度不可以超过20个字符'), trigger: 'blur' },
        ],

        address: [{ required: true, message: $t('请选择地址'), trigger: 'blur' }],
        DetailedAddress: [
          { required: true, message: $t('请输入详细地址'), trigger: 'blur' },
          { max: 100, message: $t('长度不可以超过100个字符'), trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    labelWith() {
      if (getLocale() === 'en-US') {
        return '140px'
      }

      return '80px'
    },
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const data = {
            contact: this.form.user,
            contactNumber: this.form.phone,
            province: this.form.address[0],
            city: this.form.address[1],
            area: this.form.address[2],
            addressDetail: this.form.DetailedAddress,
            defaultFlag: this.form.defaultFlag,
          }
          this.$ajax(this.$url.addAddress(), {
            ...data,
          }).then(res => {
            this.$message({
              message: res.message,
              type: 'success',
            })
            this.getAddress(res.data.addressId)
            this.dialogVisible = false
          })
        }
      })
    },
    openDialog() {
      this.getNodes()
      this.form.address = []
      this.form.user = ''
      this.form.phone = ''
      this.form.DetailedAddress = ''
      this.dialogVisible = true
    },
    handleItemChange(val) {
      this.getNodes(val)
    },
    getNodes(val) {
      // 选择省市区
      let idArea
      let sizeArea
      if (!val) {
        idArea = null
        sizeArea = 0
      } else if (val.length === 1) {
        idArea = val[0]
        sizeArea = val.length
      } else if (val.length === 2) {
        idArea = val[1]
        sizeArea = val.length
      }
      this.$ajax(this.$url.getAddress(), {
        addressCode: idArea,
      }).then(response => {
        const Items = response.data.addressTags
        if (sizeArea === 0) {
          this.cascaderData = Items.map((value, i) => ({
            addressCode: value.addressCode,
            address: value.address,
            cities: [],
          }))
        } else if (sizeArea === 1) {
          this.cascaderData.forEach(pro => {
            if (pro.addressCode === val[0]) {
              if (!pro.cities.length) {
                pro.cities = Items.map(city => ({
                  addressCode: city.addressCode,
                  address: city.address,
                  cities: [],
                }))
              }
            }
          })
        } else if (sizeArea === 2) {
          this.cascaderData.forEach(pro => {
            if (pro.addressCode === val[0]) {
              pro.cities.forEach(city => {
                if (city.addressCode === val[1]) {
                  if (!city.cities.length) {
                    city.cities = Items.map(value => ({
                      addressCode: value.addressCode,
                      address: value.address,
                    }))
                  }
                }
              })
            }
          })
        }
      })
    },
    getAddress(choosedAdd) {
      this.$ajax(this.$url.getExpressAddress(), {
        offset: 0,
        size: 1000,
      }).then(res => {
        this.addresses = res.data.addresses
        if (this.addresses.length > 0) {
          this.choosedAdd = choosedAdd || this.addresses[0].addressId
        }
      })
    },
  },
  watch: {
    choosedAdd(val) {
      const address = this.addresses.filter(item => item.addressId === val)[0]
      const data = {
        receiverAddress: address.addressAll,
        receiverName: address.contact,
        receiverPhone: address.contactNumber,
      }
      this.$emit('getVal', data)
    },
  },
  created() {
    this.getAddress()
  },
}
</script>
<style lang="less" scoped>
.main {
  background: #fafafa;
  padding: 16px;
  &-header {
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e4e4e4;
    color: #333333;
  }
}
.main-body {
  margin: 16px 0;
}
.defaultAdd {
  background: #f0f8ff;
  position: relative;
  &::after {
    content: '默认收货地址';
    position: absolute;
    right: 0;
    top: 0;
    width: 90px;
    height: 24px;
    color: white;
    font-size: 12px;
    background: #0975e0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0px 3px 0px 8px;
  }
}

/deep/ .es-radio {
  width: 100%;
  display: flex;
  height: 40px;
  align-items: center;
  padding-left: 16px;
  font-size: 14px;
  color: #333;
  font-weight: 400;
  background: #ffffff;
  margin-bottom: 8px;
}
/deep/ .is-checked {
  background: #f0f8ff;
}
/deep/ .es-radio__label {
  display: flex;
}
.phone {
  width: 100px;
}
.name {
  width: 100px;
  font-weight: 600;
}
.es-icon-d-arrow-right {
  transform: rotate(90deg);
  margin-left: 5px;
}
.rotate90 {
  transform: rotate(-90deg);
}
.main-footer {
  font-size: 12px;
  color: #666666;
  > span,
  i {
    cursor: pointer;
  }
}
.demo-form-inline {
  width: 100%;
  margin: 0 auto;
}
.dialog {
  overflow: hidden;
  &-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    &-btn {
      cursor: pointer;
      width: 80px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      margin: 0 10px 20px 10px;
      &:nth-child(1) {
        background: #0975e0ff;
        color: white;
      }
      &:nth-child(2) {
        background: #e4e4e4;
        color: #727272;
      }
    }
  }
}
</style>
